import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authenticated: false,
    viewerPath: "",
    viewerIosPath:"",
    fileDetail: "",

    sharefileSlug: "",

    //recent added
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    drawer: null,
    //recent Added

    augmentableTheme: "",
    iconrowSize:"150",
    userType:"basic",
    tags:[],
    editorSidebar:true,

    activateShowUpload: false,
    uploadAssetFormData: null,
  },
  getters: {
    checkTheme(state) {
      return state.augmentableTheme
    },
    iconrowSize: (state) => {
       return state.iconrowSize;
    },            
       
  },
  mutations: {
    setAuthentication(state, status) {
      state.authenticated = status;
    },
    setViewerPath(state, status) {
      state.viewerPath = status;
    },
    setViewerIosPath(state, status){
      state.viewerIosPath = status;
    },
    setFileDetail(state, status) {
      state.fileDetail = status;
    },

    setShareFileSlug(state, status) {
      state.sharefileSlug = status;
    },

    //recent Added
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    //recent Added

    setAugmentableTheme(state, status) {
      state.augmentableTheme = status;
    },
    setIconRowSize(state, status) {
      state.iconrowSize = status;
    },
    setUserType(state, status) {
      state.userType = status;
    },
    setTags(state, status) {
      state.tags = status;
    },
    setEditorSidebar(state, status){
      state.editorSidebar = status;
    },

    

    setActivateshowUpload(state, status){
      state.activateShowUpload = status;
    },
    setUploadAssetFormData(state,status){
      state.uploadAssetFormData =  status;
    },
  },
  plugins: [createPersistedState({
    paths: ['authenticated', 'viewerPath', 'viewerIosPath','fileDetail', 'sharefileSlug' ,'barColor', 'barImage', 'drawer', 'augmentableTheme', 'iconrowSize','userType','tags','editorSidebar','activateShowUpload','setUploadAssetFormData',]
  })],
  actions: {},
  modules: {}
})